import { JobSearchStatus } from '@internal/types/profile';

export const JOB_SEARCH_OPTIONS: Array<{
  label: string;
  value: JobSearchStatus;
}> = [
  { label: 'Actively looking', value: JobSearchStatus.ActivelyLooking },
  { label: 'Open to offers', value: JobSearchStatus.OpenToOffers },
  {
    label: 'Not looking but curious',
    value: JobSearchStatus.NotLookingButCurious,
  },
];

export const MAX_CV_SIZE_MB = 20;
